<template>
  <div>
    <v-dialog v-model="dialog" width="1200" persistent>
      <v-card
        class="rounded-lg"
        style="display: flex; flex-direction: column; height: 90vh"
      >
        <v-card-title
          style="
            background-color: #373f49 !important;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: white;
          "
        >
          <div>
            <span
              class="font-weight-bold text-h6"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
              >{{ main_title }}</span
            >
            <div
              class="text-caption"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              {{ sub_title }}
            </div>
          </div>
          <v-btn
            :disabled="loading"
            flat
            icon
            color="primary"
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Search and Filter Bar -->
        <!-- <v-card-text class="pa-3">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search users by username or stake"
                variant="outlined"
                density="comfortable"
                hide-details
                clearable
                style="font-family: Saira Condensed, sans-serif;"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="statusFilter"
                label="Filter by Status"
                variant="outlined"
                density="comfortable"
                hide-details
                :items="statusFilterOptions"
                style="font-family: Saira Condensed, sans-serif;"
                clearable
              />
            </v-col>
            <v-col cols="12" md="3" class="d-flex align-center">
              <v-btn
                @click="refreshData"
                :loading="loading"
                color="primary"
                variant="outlined"
                style="font-family: Saira Condensed, sans-serif;"
              >
                <v-icon left>mdi-refresh</v-icon>
                Refresh Data
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text> -->

        <v-divider></v-divider>

        <v-card-text style="overflow-y: auto; flex: 1; padding: 0">
          <!-- Loading State -->
          <div v-if="loading" class="pa-4">
            <v-progress-linear
              indeterminate
              color="primary"
              class="mb-4"
            ></v-progress-linear>
            <v-skeleton-loader
              v-for="n in 5"
              :key="n"
              type="list-item-two-line"
              class="mb-2"
            ></v-skeleton-loader>
          </div>

          <!-- User List -->
          <div v-else-if="filteredUsers.length > 0">
            <v-list class="pa-0">
              <v-list-item
                v-for="user in paginatedUsers"
                :key="user._id"
                class="user-milestone-item"
                style="border-bottom: 1px solid #e0e0e0"
              >
                <template v-slot:prepend>
                  <v-avatar color="primary" size="40">
                    <v-icon color="white">mdi-account</v-icon>
                  </v-avatar>
                </template>

                <v-list-item-content>
                  <v-list-item-title
                    class="font-weight-bold"
                    style="
                      font-family:
                        Saira Condensed,
                        sans-serif;
                    "
                  >
                    {{ user.username }}
                    <v-chip
                      v-if="user.stake"
                      size="small"
                      color="info"
                      variant="flat"
                      class="ml-2"
                    >
                      {{ $t("WagerUserMilestones.Stake") }}: {{ user.stake }}
                    </v-chip>
                  </v-list-item-title>

                  <v-list-item-subtitle
                    style="
                      font-family:
                        Saira Condensed,
                        sans-serif;
                    "
                  >
                    <div class="d-flex align-center mb-1">
                      <v-icon size="16" class="mr-1">mdi-cash</v-icon>
                      <span
                        >{{ $t("WagerUserMilestones.TotalWager") }}:
                        <strong
                          >${{
                            formatCurrency(user.totalWager?.totalWager || 0)
                          }}</strong
                        ></span
                      >
                    </div>

                    <!-- User Milestones Progress -->
                    <div class="mt-2">
                      <div
                        v-if="user.milestones && user.milestones.length > 0"
                        class="milestone-progress"
                      >
                        <div class="d-flex flex-wrap gap-2">
                          <v-chip
                            v-for="milestone in user.milestones"
                            :key="milestone._id"
                            :color="getMilestoneStatusColor(milestone.status)"
                            size="small"
                            variant="flat"
                            class="d-flex align-center"
                          >
                            <v-icon
                              :icon="getMilestoneStatusIcon(milestone.status)"
                              size="12"
                              class="mr-1"
                            />

                            ${{
                              formatCurrency(milestone.milestone.requiredWager)
                            }}
                            → ${{ formatCurrency(milestone.milestone.reward) }}

                            <!-- CLAIMED -->
                            <span v-if="milestone.isClaimed" class="ml-1"
                              >({{ $t("WagerUserMilestones.Claimed") }})</span
                            >

                            <!-- READY TO CLAIM (completed) -->
                            <span
                              v-else-if="milestone.status === 'COMPLETED'"
                              class="ml-1"
                              >({{ $t("WagerUserMilestones.Ready") }})</span
                            >

                            <!-- MARK AS CLAIMED BUTTON (always visible when not claimed) -->
                            <v-btn
                              v-if="
                                milestone.status === 'COMPLETED' &&
                                !milestone.isClaimed
                              "
                              size="x-small"
                              color="primary"
                              class="ml-2"
                              :loading="claimingMilestone === milestone._id"
                              @click.stop="forceClaim(milestone)"
                            >
                              {{ $t("WagerUserMilestones.MarkAsClaimed") }}
                            </v-btn>
                          </v-chip>
                        </div>
                      </div>
                      <div v-else class="text-grey">
                        {{ $t("WagerUserMilestones.NoMilestonesAvailable") }}
                      </div>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <template v-slot:append>
                  <div class="d-flex flex-column align-center">
                    <!-- Claim buttons for completed milestones -->
                    <div
                      v-if="getClaimableMilestones(user).length > 0"
                      class="mb-2"
                    >
                      <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            color="success"
                            size="small"
                            variant="elevated"
                            style="
                              font-family:
                                Saira Condensed,
                                sans-serif;
                            "
                          >
                            <v-icon left size="16">mdi-gift</v-icon>
                            {{ $t("WagerUserMilestones.Claim") }} ({{
                              getClaimableMilestones(user).length
                            }})
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            v-for="milestone in getClaimableMilestones(user)"
                            :key="milestone._id"
                            @click="claimMilestone(milestone)"
                            :disabled="claimingMilestone === milestone._id"
                          >
                            <v-list-item-title>
                              ${{
                                formatCurrency(
                                  milestone.milestone.requiredWager,
                                )
                              }}
                              {{ $t("WagerUserMilestones.Milestone") }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ $t("WagerUserMilestones.Reward") }}: ${{
                                formatCurrency(milestone.milestone.reward)
                              }}
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <!-- Progress indicator -->
                    <div class="text-center">
                      <div class="text-caption text-grey">
                        {{ $t("WagerUserMilestones.Progress") }}:
                        {{ getCompletedMilestonesCount(user) }}/{{
                          getTotalMilestonesCount(user)
                        }}
                      </div>
                      <v-progress-linear
                        :model-value="getMilestoneProgress(user)"
                        color="primary"
                        height="4"
                        class="mt-1"
                        style="width: 60px"
                      ></v-progress-linear>
                    </div>
                  </div>
                </template>
              </v-list-item>
            </v-list>

            <!-- Pagination -->
            <div class="pa-4">
              <v-pagination
                v-model="currentPage"
                :length="totalPages"
                :total-visible="7"
                class="justify-center"
              ></v-pagination>
            </div>
          </div>

          <!-- Empty State -->
          <div v-else class="pa-8 text-center">
            <v-icon size="64" color="grey" class="mb-4"
              >mdi-account-search</v-icon
            >
            <div class="text-h6 text-grey mb-2">
              {{ $t("WagerUserMilestones.NoUsersFound") }}
            </div>
            <div class="text-body-2 text-grey">
              {{
                search
                  ? $t("WagerUserMilestones.NoUsersMatchSearch")
                  : $t("WagerUserMilestones.NoUserDataAvailable")
              }}
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
          <div
            class="text-caption text-grey"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          >
            {{ $t("WagerUserMilestones.TotalUsersLabel") }}: {{ totalUsers }} |
            {{ $t("WagerUserMilestones.Showing") }} {{ paginatedUsers.length }}
            {{ $t("WagerUserMilestones.Of") }} {{ filteredUsers.length }}
            {{ $t("WagerUserMilestones.Users") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            class="text-subtitle-1"
            text="Close"
            variant="outlined"
            @click="closeDialog()"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      :color="snackbarColor"
      location="top"
    >
      <v-icon>{{ snackbarIcon }}</v-icon>
      <span
        class="ml-2"
        style="
          font-family:
            Saira Condensed,
            sans-serif;
        "
        >{{ snackText }}</span
      >
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["refresh"],
  data() {
    return {
      dialog: false,
      main_title: null,
      sub_title: null,
      loading: false,

      snackbar: false,
      snackText: null,
      snackbarColor: "success",
      snackbarIcon: "mdi-check-circle",

      wagerRewardId: null,
      users: [],
      search: "",
      statusFilter: null,
      claimingMilestone: null,

      // Pagination
      currentPage: 1,
      itemsPerPage: 10,
      totalUsers: 0,

      statusFilterOptions: [
        { title: "All", value: null },
        { title: "Not Started", value: "NOT_STARTED" },
        { title: "In Progress", value: "IN_PROGRESS" },
        { title: "Completed", value: "COMPLETED" },
        { title: "Claimed", value: "CLAIMED" },
      ],

      milestoneStatusColors: {
        NOT_STARTED: "grey",
        IN_PROGRESS: "orange",
        COMPLETED: "green",
        CLAIMED: "blue",
      },

      milestoneStatusIcons: {
        NOT_STARTED: "mdi-clock-outline",
        IN_PROGRESS: "mdi-progress-clock",
        COMPLETED: "mdi-check-circle",
        CLAIMED: "mdi-gift",
      },
    };
  },
  computed: {
    filteredUsers() {
      let filtered = this.users;

      // Search filter
      if (this.search) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter(
          (user) =>
            user.username?.toLowerCase().includes(searchTerm) ||
            user.stake?.toLowerCase().includes(searchTerm),
        );
      }

      // Status filter
      if (this.statusFilter) {
        filtered = filtered.filter((user) => {
          if (!user.milestones || user.milestones.length === 0) {
            return this.statusFilter === "NOT_STARTED";
          }
          return user.milestones.some(
            (milestone) => milestone.status === this.statusFilter,
          );
        });
      }

      return filtered;
    },
    paginatedUsers() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredUsers.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredUsers.length / this.itemsPerPage);
    },
  },
  methods: {
    async initView(wagerReward) {
      this.dialog = true;
      this.main_title = `${this.$t("WagerUserMilestones.TitlePrefix")} - ${wagerReward.leaderboardType}`;
      this.sub_title = this.$t("WagerUserMilestones.SubTitle");
      this.wagerRewardId = wagerReward._id;

      await this.loadUserData();
    },

    async loadUserData() {
      if (!this.wagerRewardId) return;

      this.loading = true;
      const token = localStorage.getItem("abughazi-admin-accesstoken");

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_SERVER_URL}/api/admin/wager-rewards/${this.wagerRewardId}/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
            },
          },
        );

        if (response.data) {
          this.users = (response.data.users || []).map((user) => {
            if (user.milestones) {
              user.milestones = user.milestones.map((milestone) => ({
                ...milestone,
                status: String(milestone.status).toUpperCase(),
              }));
            }
            return user;
          });

          this.totalUsers =
            response.data.pagination?.total || this.users.length;
        }
      } catch (error) {
        this.showError(this.$t("WagerUserMilestones.FailedToLoadData"));
        console.error("Error loading user data:", error);
      } finally {
        this.loading = false;
      }
    },

    async refreshData() {
      await this.loadUserData();
      this.showSuccess(this.$t("WagerUserMilestones.DataRefreshed"));
    },

    async claimMilestone(milestone) {
      if (this.claimingMilestone === milestone._id) return;

      this.claimingMilestone = milestone._id;
      const token = localStorage.getItem("abughazi-admin-accesstoken");

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_SERVER_URL}/api/admin/wager-rewards/milestones/${milestone._id}/claim`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
            },
          },
        );

        if (response.data && response.data.userMilestone) {
          const updated = response.data.userMilestone;

          // Update local UI
          this.updateMilestoneStatus(
            updated._id,
            updated.status.toUpperCase(), // "claimed"
            updated.isClaimed,
          );

          this.showSuccess(
            `${this.$t("WagerUserMilestones.MilestoneClaimedSuccess")}: $${this.formatCurrency(
              milestone.milestone.reward,
            )}`,
          );
          this.$emit("refresh");
        }
      } catch (error) {
        if (error.response?.status === 400) {
          this.showError(
            error.response.data.message ||
              this.$t("WagerUserMilestones.UnableToClaimMilestone"),
          );
        } else {
          this.showError(this.$t("WagerUserMilestones.FailedToClaimMilestone"));
        }
        console.error("Error claiming milestone:", error);
      } finally {
        this.claimingMilestone = null;
      }
    },

    async forceClaim(milestone) {
      if (this.claimingMilestone === milestone._id) return;

      this.claimingMilestone = milestone._id;
      const token = localStorage.getItem("abughazi-admin-accesstoken");

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_SERVER_URL}/api/admin/wager-rewards/milestones/${milestone._id}/claim`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
            },
          },
        );

        if (response.data && response.data.userMilestone) {
          const updated = response.data.userMilestone;

          this.updateMilestoneStatus(
            updated._id,
            updated.status.toUpperCase(),
            updated.isClaimed,
          );

          this.showSuccess(
            this.$t("WagerUserMilestones.MilestoneMarkedAsClaimed"),
          );
          this.$emit("refresh");
        }
      } catch (error) {
        console.error(error);
        this.showError(this.$t("WagerUserMilestones.FailedToMarkAsClaimed"));
      } finally {
        this.claimingMilestone = null;
      }
    },

    updateMilestoneStatus(milestoneId, status, isClaimed = false) {
      this.users.forEach((user) => {
        if (user.milestones) {
          user.milestones.forEach((milestone) => {
            if (milestone._id === milestoneId) {
              milestone.status = String(status).toUpperCase();
              milestone.isClaimed = isClaimed;
              if (isClaimed) {
                milestone.claimedAt = new Date().toISOString();
              }
            }
          });
        }
      });
    },

    getClaimableMilestones(user) {
      if (!user.milestones) return [];
      return user.milestones.filter(
        (milestone) => milestone.status === "COMPLETED" && !milestone.isClaimed,
      );
    },

    getCompletedMilestonesCount(user) {
      if (!user.milestones) return 0;
      return user.milestones.filter(
        (milestone) =>
          milestone.status === "COMPLETED" || milestone.status === "CLAIMED",
      ).length;
    },

    getTotalMilestonesCount(user) {
      return user.milestones?.length || 0;
    },

    getMilestoneProgress(user) {
      const total = this.getTotalMilestonesCount(user);
      if (total === 0) return 0;
      const completed = this.getCompletedMilestonesCount(user);
      return (completed / total) * 100;
    },

    getMilestoneStatusColor(status) {
      return this.milestoneStatusColors[status] || "grey";
    },

    getMilestoneStatusIcon(status) {
      return this.milestoneStatusIcons[status] || "mdi-help-circle";
    },

    formatCurrency(amount) {
      if (!amount) return "0.00";
      return Number(amount).toFixed(2);
    },

    showSuccess(message) {
      this.snackText = message;
      this.snackbarColor = "success";
      this.snackbarIcon = "mdi-check-circle";
      this.snackbar = true;
    },

    showError(message) {
      this.snackText = message;
      this.snackbarColor = "error";
      this.snackbarIcon = "mdi-alert-circle";
      this.snackbar = true;
    },

    closeDialog() {
      this.dialog = false;
      this.users = [];
      this.search = "";
      this.statusFilter = null;
      this.currentPage = 1;
      this.wagerRewardId = null;
    },
  },
});
</script>

<style scoped>
.user-milestone-item {
  transition: background-color 0.2s;
}

.user-milestone-item:hover {
  background-color: #f5f5f5;
}

.milestone-progress .v-chip {
  margin: 2px;
}

.gap-2 > * + * {
  margin-left: 8px;
}
</style>
